import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { User } from 'src/app/db/models/user';
import { AuthenticationService } from 'src/app/services/authentication.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {

  currentUser: User;

  constructor(
    private authenticate: AuthenticationService,
    private router: Router,
    private notify: ToastrService)
    {
      this.authenticate.currentUser.subscribe(x => this.currentUser = x);
      // this.successNotification();
    }

  ngOnInit() {
  }

  successNotification(){
    Swal.fire({
      // title: 'Are you sure?',
      text: "You can always log in at any time",
      icon: 'info',
    }).then((result) => {
      if (result.isConfirmed) {
        this.logOut();
      }
    })
  }

  logOut() {
    this.authenticate.logout();
    this.router.navigate(['/']);
    this.notify.success('Logged Out Succesfully');
  }

}
